import axiosInstance from './axiosInstance';

/**
 * Todo Service
 * Handles all To-Do related API calls
 */
const todoService = {
  /**
   * Get all todos for the organization
   */
  getAllTodos: async () => {
    try {
      const response = await axiosInstance.get('/carehome-manager/todos');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error fetching todos' };
    }
  },

  /**
   * Create a new todo
   */
  createTodo: async (todoData) => {
    try {
      const response = await axiosInstance.post('/carehome-manager/todos', todoData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error creating todo' };
    }
  },

  /**
   * Update an existing todo
   */
  updateTodo: async (id, todoData) => {
    try {
      const response = await axiosInstance.put(`/carehome-manager/todos/${id}`, todoData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error updating todo' };
    }
  },

  /**
   * Delete a todo
   */
  deleteTodo: async (id) => {
    try {
      const response = await axiosInstance.delete(`/carehome-manager/todos/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error deleting todo' };
    }
  }
};

export default todoService;
